// extracted by mini-css-extract-plugin
export var btn = "HeroCard-module--btn--c327f";
export var contentContainer = "HeroCard-module--contentContainer--507cf";
export var flex = "HeroCard-module--flex--fd6d4";
export var fullImage = "HeroCard-module--fullImage--6faee";
export var heading = "HeroCard-module--heading--4bf98";
export var hero = "HeroCard-module--hero--69487";
export var heroLink = "HeroCard-module--heroLink--9bc72";
export var highlight = "HeroCard-module--highlight--7b8ea";
export var icon = "HeroCard-module--icon--1bcde";
export var image = "HeroCard-module--image--ceaef";
export var imageWrapper = "HeroCard-module--imageWrapper--dc881";
export var link = "HeroCard-module--link--3de6a";
export var linkText = "HeroCard-module--linkText--7d287";
export var primary = "HeroCard-module--primary--df5ca";
export var slot = "HeroCard-module--slot--171c7";
export var subheading = "HeroCard-module--subheading--a875b";
export var wedding = "HeroCard-module--wedding--329cd";